"use client";

import React from 'react';

export default function QuickAccessBar({ centresCount, servicesCount, prestatairesCount }: { centresCount: number; servicesCount: number; prestatairesCount: number }) {
  const quickItems = [
  {
    label: 'Nos centres',
    href: '#centres',
    icon:
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>,

    description: `${centresCount} centres à Bruxelles et Brabant flamand`
  },
  {
    label: 'Nos services',
    href: '#services',
    icon:
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>,

    description: `${servicesCount} spécialités médicales`
  },
  {
    label: 'Nos prestataires',
    href: '/prestataires',
    icon:
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>,

    description: `${prestatairesCount} professionnels`
  },
  {
    label: 'Contact',
    href: '/contact',
    icon:
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>,

    description: 'Répondre à vos questions'
  }];
  return (
    <section className="py-0 relative z-10 bg-transparent" aria-label="Accès rapide">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 border border-border rounded-card shadow-card -mt-16 bg-white overflow-hidden">
          {quickItems?.map((item, index) =>
          <a
            key={item?.label}
            href={item?.href}
            className={`quick-access-item flex flex-col items-center text-center p-6 md:p-8 group cursor-pointer ${index < quickItems?.length - 1 ? 'border-r border-b lg:border-b-0 border-border' : 'border-b lg:border-b-0'} ${index === 1 ? 'border-b lg:border-b-0' : ''}`}
            aria-label={`${item?.label} - ${item?.description}`}>

              <div
              className="quick-icon w-14 h-14 rounded-full bg-primary-soft flex items-center justify-center text-primary mb-4 group-hover:bg-primary group-hover:text-white transition-all duration-300"
              aria-hidden="true">

                {item?.icon}
              </div>
              <span
              className="font-semibold text-text-main text-sm md:text-base mb-1"
              style={{ fontFamily: 'Poppins, sans-serif' }}>

                {item?.label}
              </span>
              <span
              className="text-text-muted text-xs leading-relaxed hidden md:block"
              style={{ fontFamily: 'Poppins, sans-serif' }}>

                {item?.description}
              </span>
            </a>
          )}
        </div>
      </div>
    </section>);

}